import { AnyAction } from 'redux';

const MOVETAB_VALUE = 'MOVETAB_VALUE';
const initialState = {
  MoveTabValue: true
};

export async function setMoveTabValue(dispatch: any, MoveTabValue: any) {
  dispatch({
    type: MOVETAB_VALUE,
    data: MoveTabValue
  });
}

const MoveTabReducer = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case MOVETAB_VALUE: {
      return {
        ...state,
        MoveTabValue: action.data
      };
    }

    default:
      return state;
  }
};

export default MoveTabReducer;
